import { Category } from '@modules/common/types';
import { ManipulationType } from 'generated/graphql';
import { EntityLabel, ReasonLabel } from 'v2/core/entities/feedback/labels';

interface GetEditPredictionOptions {
  label: ReasonLabel | EntityLabel;
  category?: Category;
}

export const getEditPrediction = ({
  label,
  category,
}: GetEditPredictionOptions) => {
  return label.type === 'REASON'
    ? {
        type: label.type,
        manipulationType: ManipulationType.Remove,
        prediction: label,
      }
    : {
        type: label.type,
        manipulationType: ManipulationType.Remove,
        category,
        prediction: label,
      };
};
